import React from "react";
import "./Loading.css";
// @ts-ignore
import { ReactComponent as Spinner } from "../../../assets/icons/circle-notch.svg";

interface LoadingProps {
  size?: "small" | "medium" | "large";
}

const Loading: React.FC<LoadingProps> = (props) => {
  let spinnerClass = "d-inline-block align-top spinner";
  if (props.size === "small") {
    spinnerClass = spinnerClass + " spinner-small";
  }
  return (
    <div className="text-center">
      <Spinner alt="spinner" className={spinnerClass} />
    </div>
  );
};

export default Loading;
